export default __webpack_public_path__ + "static/media/noWxWarnIcon.d68b3867.png";